import { Drawer as BaseDrawer } from '@base-ui/react';

import { DrawerActions } from './DrawerActions';
import { DrawerContent } from './DrawerContent';
import { DrawerHeader } from './DrawerHeader';
import { DrawerPopup } from './DrawerPopup';
import { DrawerRoot } from './DrawerRoot';

export const Drawer = {
  Root: DrawerRoot,
  Trigger: BaseDrawer.Trigger,
  Title: BaseDrawer.Title,
  Popup: DrawerPopup,
  Header: DrawerHeader,
  Content: DrawerContent,
  Actions: DrawerActions,
  Close: BaseDrawer.Close,
};
